import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';

import { submit, isSubmitting } from 'redux-form';

import Button from 'components/common/Button';
import PrescriberCreateEditForm from './PrescriberCreateEditForm';

const styles = theme => ({
  form: {
    overflow: 'hidden',
    padding: '25px 30px 105px',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      paddingRight: 0,
      paddingBottom: 0,
      overflow: 'visible',
    },
  },
});

const PrescriberCreateEditDialog = ({
  form,
  initialValues,
  ID,
  open,
  onClose,
  onSearchButtonClick,
  onSubmitSuccess,
  submitting,
  actions,
  destroyOnUnmount,
  classes,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
  >
    <DialogTitle onCloseClick={onClose}>
      <Typography
        variant="title"
        color="secondary"
        align="center"
      >
        {ID ? 'Edit Prescriber' : 'Add Prescriber'}
      </Typography>
    </DialogTitle>
    <DialogContent withScrollbars>
      <PrescriberCreateEditForm
        className={classes.form}
        form={form}
        {...initialValues ? { initialValues } : {}}
        {...ID ? { ID } : {}}
        destroyOnUnmount={destroyOnUnmount}
        onSubmitSuccess={(values) => {
          onClose();
          onSubmitSuccess(values);
        }}
      />
    </DialogContent>
    <DialogActions>
      <Button
        onClick={onSearchButtonClick}
        variant="raised"
      >
        {ID ? 'Find in registry' : 'Back'}
      </Button>
      <Button
        onClick={() => actions.submit(form)}
        variant="raised"
        color="primary"
        disabled={submitting}
      >
        {ID ? 'Update Prescriber' : 'Add Prescriber'}
      </Button>
    </DialogActions>
  </Dialog>
);

PrescriberCreateEditDialog.propTypes = {
  open: PropTypes.bool,
  form: PropTypes.string.isRequired,
  initialValues: PropTypes.shape({
    'First Name': PropTypes.string,
    'Last Name': PropTypes.string,
    Phone: PropTypes.string,
    Fax: PropTypes.string,
    Email: PropTypes.string,
    NPI: PropTypes.string,
    LIC: PropTypes.string,
    DEA: PropTypes.string,
  }),
  ID: PropTypes.number,
  onClose: PropTypes.func,
  onSearchButtonClick: PropTypes.func,
  onSubmitSuccess: PropTypes.func,
  submitting: PropTypes.bool.isRequired,
  destroyOnUnmount: PropTypes.bool,
  actions: PropTypes.shape({
    submit: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    form: PropTypes.string.isRequired,
  }).isRequired,
};

PrescriberCreateEditDialog.defaultProps = {
  open: false,
  initialValues: null,
  ID: null,
  destroyOnUnmount: true,
  onClose: () => {},
  onSubmitSuccess: () => {},
  onSearchButtonClick: () => {},
};

const mapStateToProps = (store, ownProps) => ({
  submitting: isSubmitting(ownProps.form)(store),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ submit }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(PrescriberCreateEditDialog),
);



// WEBPACK FOOTER //
// ./src/components/settings/PrescriberCreateEditDialog/PrescriberCreateEditDialog.js